import { render, staticRenderFns } from "./UsuarioEdit.vue?vue&type=template&id=b67b5e9a&scoped=true&"
import script from "./UsuarioEdit.vue?vue&type=script&lang=js&"
export * from "./UsuarioEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioEdit.vue?vue&type=style&index=0&id=b67b5e9a&prod&scoped=true&lang=css&"
import style1 from "./UsuarioEdit.vue?vue&type=style&index=1&id=b67b5e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67b5e9a",
  null
  
)

export default component.exports